import { useState, useEffect } from 'react';

export const formatTime = (time: number) => {
  return time < 10 ? `0${time}` : time;
};

export const formatPrice = (price: string | number) => {
  const priceFormatString = window?.formattedString;
  const priceNumber = typeof price === 'number' ? price : parseFloat(price);
  const formattedPrice = priceNumber.toFixed(2);

  if (priceFormatString) {
    const priceString = priceFormatString.replace(/(0\.00|0,00|0)/, formattedPrice);
    return priceString;
  } else {
    if (price) {
      return `$${formattedPrice}`;
    } else return;
  }
};

export function useIsDesktop() {
  const getIsDesktop = () => (typeof window !== 'undefined' ? window.innerWidth >= 1280 : false);

  const [isDesktop, setIsDesktop] = useState(getIsDesktop);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1280);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isDesktop;
}
